import { ReactElement } from 'react';

import { QueueCompositeProfileParam } from './params/QueueCompositeProfileParam';
import { QueueCompositeProfileItemActions } from './QueueCompositeProfileItemActions';
import { IItemActionsProps, QueueTypeHandler } from '../QueueTypeHandler';

export class CompositeProfileHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = ['.pdf'];

    renderParams(onParamsChange?: (params: Record<string, unknown>) => void, initialValues?: Record<string, string>): ReactElement {
        return <QueueCompositeProfileParam onParamsChange={onParamsChange} initialValues={initialValues} />;
    }

    renderItemActions({ entityKey, queueToken, isExpanded }: IItemActionsProps): ReactElement {
        return <QueueCompositeProfileItemActions entityKey={entityKey} queueToken={queueToken} isExpanded={isExpanded} />;
    }
}
